import {
  createContext, useContext, useMemo, useState,
} from 'react';

type Props = {
  children: React.ReactNode;
};

interface ActiveStepContextType {
  activeStep: string;
  setActiveStep: React.Dispatch<React.SetStateAction<string>>
}

const activeStepContext = createContext({} as ActiveStepContextType);

export const ActiveStepContextProvider = ({ children }: Props) => {
  const [activeStep, setActiveStep] = useState('step_1');
  const activeStepMemoized = useMemo(() => (
    { activeStep, setActiveStep }), [activeStep, setActiveStep]);

  return (
    <activeStepContext.Provider value={activeStepMemoized}>
      { children }
    </activeStepContext.Provider>
  );
};

export const useActiveStepContext = () => useContext(activeStepContext);
